export default __webpack_public_path__ + "static/media/vehicle_active_back_left.82519f9f.svg";